import './style/background.scss';

export default function Background() {
  return <div className="ellipsis-blur"></div>;
}
